<template>
    <validation-observer v-slot="{ meta, setFieldValue, errors }">
        <div class="payment-gateway-page-wrapper payment-types-gap">
            <div class="d-flex flex-column card p-3">
                <div class="d-flex flex-wrap align-items-center card-wrapper pt-5 mb-5">
                    <div class="d-flex align-items-center" v-for="card in Object.keys(creditCards)" :key="card">
                        <form-checkbox
                            class="mb-0 card-checkbox"
                            @input="(val) => onChangeCreditCard(val, card)"
                            :value="creditCards[card]"
                        >
                            <div class="d-flex w-100 align-items-center card-image">
                                <img class="mr-2 card-icon" :src="CREDIT_CART_TYPES[card].logo" alt="" />
                            </div>
                        </form-checkbox>
                    </div>
                </div>
                <validation-provider
                    class="credit-card-note"
                    rules="maxMessageLen:255, Credit card note"
                    name="credit_card_details"
                >
                    <form-textarea
                        :value="paymentTypes.credit_card_details"
                        @change="(val) => {
                            onChangePaymentTypeDetails('credit_card_details', val)
                            setFieldValue('credit_card_details', val)
                        }"
                        :rows="5"
                        label="Note displayed to guest with paying via credit card:"
                        :error="errors.credit_card_details"
                        class="mb-0"
                    />
                </validation-provider>
            </div>

            <div class="payment-types-wrapper">
                <b-card v-if="paymentTypes.echeck" class="template sidebar-header-card payment-type-header-card">
                    <template #header>
                        <div class="d-flex align-items-center">
                            <form-checkbox
                                :value="paymentTypes.echeck.selected"
                                @change="(val) => onChangePaymentTypeDetails('echeck', val, 'selected')"
                                class="mb-0"
                            >
                                <div class="d-flex w-100 align-items-center payment-checkbox-label">
                                    <img class="mr-2" src="/static/images/billing/e-check.svg" alt="" />
                                    <span> eCheck / ACH Direct Debit </span>
                                </div>
                            </form-checkbox>
                        </div>
                    </template>
                    <b-card-body>
                        <b-row>
                            <b-col md="12">
                                <form-textarea
                                    :value="paymentTypes.echeck.echeck_details"
                                    @change="(val) => onChangePaymentTypeDetails('echeck', val, 'echeck_details')"
                                    :rows="10"
                                    label="eCheck / ACH Direct Debit details:"
                                />
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <b-card v-if="paymentTypes.check" class="template sidebar-header-card payment-type-header-card">
                    <template #header>
                        <div class="d-flex align-items-center">
                            <form-checkbox
                                :value="paymentTypes.check.selected"
                                @change="(val) => onChangePaymentTypeDetails('check', val, 'selected')"
                                class="mb-0"
                                >Check</form-checkbox
                            >
                        </div>
                    </template>
                    <b-card-body>
                        <b-row>
                            <b-col md="12">
                                <form-textarea
                                    :value="paymentTypes.check.check_policy"
                                    @change="(val) => onChangePaymentTypeDetails('check', val, 'check_policy')"
                                    :rows="10"
                                    label="Check Acceptance Policy:"
                                />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12" class="d-flex align-items-center justify-content-between">
                                <span> Allow check as payment option for online bookings? </span>
                                <form-dropdown
                                    class="mb-0"
                                    @input="(val) => onChangePaymentTypeDetails('check', val, 'allow_online_check')"
                                    :options="yesNoOptions"
                                    :value="paymentTypes.check.allow_online_check"
                                />
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <b-card v-if="paymentTypes.guest_credit" class="template sidebar-header-card payment-type-header-card">
                    <template #header>
                        <div class="d-flex align-items-center">
                            <form-checkbox
                                :value="paymentTypes.guest_credit.selected"
                                @change="(val) => onChangePaymentTypeDetails('guest_credit', val, 'selected')"
                                class="mb-0"
                                >Guest Credit</form-checkbox
                            >
                        </div>
                    </template>
                    <b-card-body>
                        <b-row>
                            <b-col md="12" class="d-flex align-items-center justify-content-between">
                                <span> Allow guest credit as a payment option for online bookings? </span>
                                <form-dropdown
                                    class="mb-0"
                                    @input="
                                        (val) =>
                                            onChangePaymentTypeDetails('guest_credit', val, 'allow_online_guest_credit')
                                    "
                                    :options="yesNoOptions"
                                    :value="paymentTypes.guest_credit.allow_online_guest_credit"
                                />
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <b-card
                    v-if="paymentTypes.gift_certificate"
                    class="template sidebar-header-card payment-type-header-card"
                >
                    <template #header>
                        <div class="d-flex align-items-center">
                            <form-checkbox
                                :value="paymentTypes.gift_certificate.selected"
                                @change="(val) => onChangePaymentTypeDetails('gift_certificate', val, 'selected')"
                                class="mb-0"
                                >Gift Certificate Credit</form-checkbox
                            >
                        </div>
                    </template>
                    <b-card-body>
                        <b-row>
                            <b-col md="12" class="d-flex align-items-center justify-content-between">
                                <span> Allow gift certificate as a payment option for online bookings? </span>
                                <form-dropdown
                                    class="mb-0"
                                    @input="
                                        (val) =>
                                            onChangePaymentTypeDetails('gift_certificate', val, 'allow_online_gift')
                                    "
                                    :options="yesNoOptions"
                                    :value="paymentTypes.gift_certificate.allow_online_gift"
                                />
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <b-card
                    v-if="paymentTypes.no_payment_required"
                    class="template sidebar-header-card payment-type-header-card"
                >
                    <template #header>
                        <div class="d-flex align-items-center">
                            <form-checkbox
                                :value="paymentTypes.no_payment_required.selected"
                                @change="(val) => onChangePaymentTypeDetails('no_payment_required', val, 'selected')"
                                class="mb-0"
                                >No Payment</form-checkbox
                            >
                        </div>
                    </template>
                    <b-card-body>
                        <b-row>
                            <b-col md="12">
                                <form-textarea
                                    :value="paymentTypes.no_payment_required.no_payment_policy"
                                    @change="
                                        (val) =>
                                            onChangePaymentTypeDetails('no_payment_required', val, 'no_payment_policy')
                                    "
                                    :rows="10"
                                    label="No Payment Required Policy:"
                                />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12" class="d-flex align-items-center justify-content-between">
                                <span> Allow no payment required as option for online bookings? </span>
                                <form-dropdown
                                    class="mb-0"
                                    @input="
                                        (val) =>
                                            onChangePaymentTypeDetails('no_payment_required', val, 'allow_no_payment')
                                    "
                                    :options="yesNoOptions"
                                    :value="paymentTypes.no_payment_required.allow_no_payment"
                                />
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <b-card v-if="paymentTypes.bank_transfer" class="template sidebar-header-card payment-type-header-card">
                    <template #header>
                        <div class="d-flex align-items-center">
                            <form-checkbox
                                :value="paymentTypes.bank_transfer.selected"
                                @change="(val) => onChangePaymentTypeDetails('bank_transfer', val, 'selected')"
                                class="mb-0"
                                >Bank Transfer</form-checkbox
                            >
                        </div>
                    </template>
                    <b-card-body>
                        <b-row>
                            <b-col md="12">
                                <form-textarea
                                    :value="paymentTypes.bank_transfer.bank_transfer_details"
                                    @change="
                                        (val) =>
                                            onChangePaymentTypeDetails('bank_transfer', val, 'bank_transfer_details')
                                    "
                                    :rows="10"
                                    label="Details:"
                                />
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>

                <b-card v-if="paymentTypes.manual_paypal" class="template sidebar-header-card payment-type-header-card">
                    <template #header>
                        <div class="d-flex align-items-center">
                            <form-checkbox
                                :value="paymentTypes.manual_paypal.selected"
                                @change="(val) => onChangePaymentTypeDetails('manual_paypal', val, 'selected')"
                                class="mb-0"
                            >
                                <div class="d-flex w-100 align-items-center payment-checkbox-label">
                                    <img
                                        class="mr-2 payment-icon"
                                        src="/static/images/billing/paypal.svg"
                                        alt=""
                                    /></div
                            ></form-checkbox>
                        </div>
                    </template>
                    <b-card-body>
                        <b-row>
                            <b-col md="12">
                                This option allows a PayPal payment to be manually recorded to a Lodgix invoice. Does
                                not allow guests to pay or be invoiced via PayPal. Pay via PayPal and invoice via Paypal
                                are only available when PayPal is selected as a payment gateway.
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <b-card v-if="paymentTypes.manual_airbnb" class="template sidebar-header-card payment-type-header-card">
                    <template #header>
                        <div class="d-flex align-items-center">
                            <form-checkbox
                                :value="paymentTypes.manual_airbnb.selected"
                                @change="(val) => onChangePaymentTypeDetails('manual_airbnb', val, 'selected')"
                                class="mb-0"
                            >
                                <div class="d-flex align-items-center payment-checkbox-label">
                                    <img
                                        class="mr-2 payment-icon"
                                        src="/static/images/billing/airbnb.svg"
                                        alt=""
                                    /></div
                            ></form-checkbox>
                        </div>
                    </template>
                    <b-card-body>
                        <b-row>
                            <b-col md="12">
                                This option allows an Airbnb payment to be manually recorded to a Lodgix invoice. Does
                                not allow guests to be invoiced via Airbnb.
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <b-card class="template sidebar-header-card payment-type-header-card">
                    <template #header> Virtual Terminal URL: </template>
                    <b-card-body>
                        <b-row>
                            <b-col md="12">
                                <form-input
                                    :value="paymentTypes.virtual_terminal_url"
                                    @change="(val) => onChangePaymentTypeDetails('virtual_terminal_url', val)"
                                />
                                <div class="text-secondary">
                                    Enter link to virtual terminal for your payment processor (authorize.net, etc.)
                                </div>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </div>
            <div class="submit-buttons-wrapper">
                <b-button variant="primary" @click="save" :disabled="!meta.valid">Save</b-button>
            </div>
        </div>
    </validation-observer>
</template>

<script>
    import { mapGetters } from 'vuex';
    import FormCheckbox from '../../generic/form-checkbox/form-checkbox.vue';
    import FormTextarea from '../../generic/form-textarea/form-textarea.vue';
    import FormDropdown from '../../generic/form-dropdown/form-dropdown.vue';
    import FormInput from '../../generic/form-input/form-input.vue';

    import { CREDIT_CART_TYPES } from '../utils.js';
    import { formatResponseError } from '../../../utils/api';

    export default {
        name: 'PaymentGatewayAcceptedTypes',
        components: { FormCheckbox, FormTextarea, FormDropdown, FormInput },
        data() {
            return {
                CREDIT_CART_TYPES,
            };
        },
        computed: {
            ...mapGetters('paymentGateway', ['paymentTypes', 'originalPaymentTypes']),
            creditCards() {
                return this.paymentTypes.credit_cards || {};
            },
            yesNoOptions() {
                return [
                    {
                        text: 'Yes',
                        value: true,
                    },
                    {
                        text: 'No',
                        value: false,
                    },
                ];
            },
        },
        mounted() {
            this.fetchPaymentTypes();
        },
        methods: {
            async fetchPaymentTypes() {
                try {
                    this.$parent.$emit('busy', true);
                    await this.$store.dispatch('paymentGateway/fetchPaymentTypes');
                } catch (e) {
                    this.errorToast({ text: 'Could not fetch payment types' });
                } finally {
                    this.$parent.$emit('busy', false);
                }
            },
            onChangeCreditCard(value, card) {
                const values = JSON.parse(JSON.stringify(this.paymentTypes));
                values.credit_cards = {
                    ...values.credit_cards,
                    [card]: value,
                };
                this.$store.commit('paymentGateway/gotPaymentTypes', values);
            },
            onChangePaymentTypeDetails(payment, value, field) {
                const values = JSON.parse(JSON.stringify(this.paymentTypes));
                if (field) {
                    values[payment][field] = value;
                } else {
                    values[payment] = value;
                }
                this.$store.commit('paymentGateway/gotPaymentTypes', values);
            },
            async save() {
                try {
                    this.$parent.$emit('busy', true);
                    await this.$store.dispatch('paymentGateway/savePaymentTypesData', this.paymentTypes);
                    this.successToast({ text: 'Data has been successfully saved' });
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({ text: generic || 'Could not save data' });
                } finally {
                    this.$parent.$emit('busy', false);
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../styles.scss';
    .card-wrapper {
        gap: 40px;
    }
    .payment-types-gap {
        gap: 30px;
        display: flex;
        flex-direction: column;
        position: relative;
    }
    .card-image {
        width: 90px;
        height: 60px;
        margin-top: -17px;
        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
    .payment-type-header-card {
        :deep(.card-header) {
            background-color: #fff !important;
            color: #0d47a1 !important;
        }
    }
    .payment-types-wrapper {
        display: grid;
        grid-template-columns: 1fr 1fr;
        justify-items: stretch;
        column-gap: 2rem;
        row-gap: 2rem;
        @media (max-width: 968px) {
            grid-template-columns: 1fr;
        }
    }
    .payment-icon {
        height: 36px;
    }
    .payment-checkbox-label {
        position: absolute;
        top: -7px;
        min-width: 250px;
    }
    .credit-card-note {
        width: 50%;
        @media (max-width: 968px) {
            width: 100%;
        }
    }
</style>
